import React from 'react';
import { TableCellActions } from '@fluentui/react-components';

type TProps = {
  children: React.ReactNode;
  alwaysVisible?: boolean;
};

/**
 * Wraps children in <TableCellActions> while
 *  - swallowing row-selection events
 *  - forcing visibility when `alwaysVisible=true`
 */
export const TableActionButtons = ({ children, alwaysVisible = false }: TProps) => {
  const stop = (e: React.SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <TableCellActions
      className="mx-2" // spacing from the right edge of the cell
      visible={alwaysVisible}
      onClick={stop}
      onKeyDown={(e) => e.key === ' ' && stop(e)}
    >
      {children}
    </TableCellActions>
  );
};
